import NumberHistoryList from './containers/NumberHistoryList';
import { Role, RouteConfig } from '@/types';
import { NUMBER_HISTORY_PATH } from '@/constants/paths';

const AllRoles = Object.values(Role);

const routes: RouteConfig[] = [
  {
    key: 'phone-history',
    path: NUMBER_HISTORY_PATH,
    title: 'Phone Number History',
    component: NumberHistoryList,
    roles: AllRoles,
  },
];

export default routes;
